import { Field, ModalStyle as Modal } from "@hubrise/react-components"
import * as React from "react"
import { Trans, useTranslation } from "react-i18next"

import { useConfig } from "shared/components/ConfigContext"

import { Email, LoggedInAs } from "./Styles"

const SettingsModalContent = ({ close }: { close: () => void }): JSX.Element => {
  const { i18n, t } = useTranslation()
  const { user } = useConfig()

  const [pureLanguage] = i18n.language.split("-")

  return (
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>{t("settings.title")}</Modal.Title>
        <Modal.Close onClick={close} />
      </Modal.Header>

      <Modal.Body>
        <Field.Select
          label={t("settings.language.title")}
          withMargin
          name="language"
          options={[
            { label: "English", value: "en" },
            { label: "Français", value: "fr" },
          ]}
          value={[pureLanguage]}
          onChange={(value: Array<string>) => void i18n.changeLanguage(value[0])}
          searchable={false}
        />

        <LoggedInAs>
          <Trans i18nKey="settings.logged_in_as" values={{ email: user.email }} components={{ email: <Email /> }} />
        </LoggedInAs>
      </Modal.Body>
    </Modal.Content>
  )
}

export default SettingsModalContent
